import React, { useEffect, useState } from "react";
import { Row, Col, Dropdown, Form, Button, Modal } from "react-bootstrap";
import ProductComponent from "../ProductComponent/ProductComponent";
import { useSelector, useDispatch } from "react-redux";
import { handleGetProductsList } from "../../store/actions/productsListsActions";
import { handleCreateProduct } from "../../store/actions/productActions";
import { handleDeleteProduct } from "../../store/actions/productActions";
import { handleGetRegionsList } from "../../store/actions/cropActions";
import { FaCalendarAlt, FaChevronDown } from "react-icons/fa";
import { ICONS } from "../../constants/constants";

const ProductListComponent = ({ title }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { regionList, cropList } = useSelector((state) => state.crop);
  const [errors, setErrors] = useState({});
  const [isAddingProduct, setIsAddingProduct] = useState(false);
  const [isDeletingProduct, setIsDeletingProduct] = useState(false);
  useEffect(() => {
    handleGetRegionsList(dispatch);
    //handleGetCropList(dispatch);
  }, [dispatch]);
  const userrole = user?.role;
  const tenantId = userrole === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin

  const [productData, setProductData] = useState({
    productName: "",
   // type: "",
    tenantId: "",
    amount: 0,
    unit: "",
   // totalUnits: 0,
    product_image: null, // Reset image file
    regionId: "",
  });

  // Access productsList from Redux store
  const { productsList } = useSelector((state) => state.product);

  const [showFilter, setShowFilter] = useState(false);
  const [dateRange, setDateRange] = useState("");

  // Fetch products when the component loads
  useEffect(() => {
    handleGetProductsList(dispatch);
  }, [dispatch]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
  
      if (!allowedTypes.includes(file.type)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          product_image: "Only JPG, JPEG, PNG, or WEBP images are allowed",
        }));
        return;
      }
  
      setProductData({ ...productData, product_image: file });
  
      // Clear the error if the file is valid
      setErrors((prevErrors) => ({
        ...prevErrors,
        product_image: "",
      }));
    }
  };
  

  const handleProductDataChange = (e) => {
    const { name, value } = e.target;
    setProductData({ ...productData, [name]: value });

     // Perform validation on change for each field
  switch (name) {
    case "productName":
      setErrors((prevErrors) => ({
        ...prevErrors,
        productName: value.trim() ? "" : "Product Name is required",
      }));
      break;

    case "amount":
      setErrors((prevErrors) => ({
        ...prevErrors,
        amount: value === "" || value <= 0 ? "Price must be greater than 0" : "",
      }));
      break;

    case "unit":
      setErrors((prevErrors) => ({
        ...prevErrors,
        unit: value.trim() ? "" : "Unit is required",
      }));
      break;

    case "regionId":
      setErrors((prevErrors) => ({
        ...prevErrors,
        regionId: value.trim() ? "" : "Product Region is required",
      }));
      break;

    default:
      break;
  }
  };

  // Handle date range changes
  const handleDateRangeChange = (e) => {
    setDateRange(e.target.value);
  };
  const [showProductModal, setShowProductModal] = useState(false);
  const handleProductModalShow = () => setShowProductModal(true);
  const handleProductModalClose = () => setShowProductModal(false);

  const addProduct = async () => {
    if (isAddingProduct) return;
    const {
      productName,
     // type,
      amount,
     // totalUnits,
      unit,
      product_image,
      regionId,
    } = productData;

    let newErrors = { productName: "", amount: "", unit: "", product_image: "", regionId: ""};
    // Validate Name
    if (!productData.productName.trim()) {
      newErrors.productName = "Product Name is required";
    }

    // Validate Price (should not be 0 or negative)
if (productData.amount === "" || productData.amount <= 0) {
  newErrors.amount = "Price must be greater than 0";
}

    if (typeof productData.unit !== "string" || !productData.unit.trim()) {
      newErrors.unit = "Unit is required";
    }
    

    if (!productData.product_image ) {
      newErrors.product_image = "Product Image is required";
    }
    if (!productData.regionId.trim()) {
      newErrors.regionId = "Product Region is required";
    }

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }

      setIsAddingProduct(true);
      try {

        // Add tenantId to productData before sending
      const updatedProductData = {
        ...productData,
        tenantId: tenantId, // Add your tenantId here dynamically
        amount: Number(amount), // Convert amount to a number
       // totalUnits: Number(totalUnits),
      };

        // Creating FormData object
        const formData = new FormData();
        formData.append("productName", productName);
       // formData.append("type", type);
        formData.append("tenantId", tenantId);
        formData.append("amount", amount);
       // formData.append("totalUnits", totalUnits);
        formData.append("unit", unit);
        formData.append("regionId", regionId);
        formData.append("product_image", product_image); // File object


      // Send productData directly as a JSON object to the API
      const result = await handleCreateProduct(formData, dispatch);
      if(result){
        window.location.reload();
      }

      } catch (error) {
        // console.error("Error creating product:", error);
      } finally {
        setIsAddingProduct(false);
      }
    
  };

  // const addProduct = async () => {

  //   const { productName, type, amount, totalUnits, unit, url, region } = productData;

  //   if (productName && type && tenantId && amount && totalUnits && unit && url && region) {
  //     try {
  //       const formData = new FormData();
  //       formData.append("productName", productName);
  //       formData.append("type", type);
  //       formData.append("tenantId", tenantId); // Use tenant ID from productData
  //       formData.append("amount", amount);
  //       formData.append("totalUnits", totalUnits);
  //       formData.append("unit", unit);
  //       formData.append("region", region); // Append the region field
  //       formData.append("product_image", url); // Append the image file
  //       await handleCreateProduct(productData, dispatch);

  //       // Reset form data
  //       setProductData({
  //         productName: "",
  //         type: "",
  //         tenantId: "",
  //         amount: 0,
  //         totalUnits: 0,
  //         unit: "",
  //         url: null, // Reset image file
  //         region: "",
  //       });
  //       handleProductModalClose();
  //       //handleGetProductList(dispatch); // Refresh products list
  //     } catch (error) {
  //       console.error("Error adding product:", error);
  //     }
  //   } else {
  //     console.error("Please fill in all fields before submitting");
  //   }
  // };

  const [showModal, setShowModal] = useState(false);   // State for showing the modal
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deletedProduct, setDeletedProduct] = useState({ product_id: '', product_name: '' });

  const handleShowModal = (product) => {
    setDeletedProduct({ product_id: product.id, product_name: product.name });
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setDeleteConfirm(false);  // Reset the delete confirm state when closing the modal
  };


  const deleteProduct = async () => {
    if (isDeletingProduct) return;
    setIsDeletingProduct(true);
    try {
      dispatch(handleDeleteProduct(deletedProduct.product_id))
        .then((result) => {
          handleCloseModal();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Delete failed:", error);
        });
    } catch (error) {
      console.error("Error deleting product:", error);
    } finally {
      setIsDeletingProduct(false);
    }
  };
  
  const handleConfirmDelete = () => {
    if (isDeletingProduct) return;
    setDeleteConfirm(true); // keep existing state
    deleteProduct(); // and trigger once immediately (prevents multi-click duplicates)
  };

  return (
    <div className="product-list-container">

<Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete product {deletedProduct.product_name}?
          {/* Add product name here if needed */}
        </Modal.Body>
        <Modal.Footer>
        <Button 
  className="reject-button" 
  style={{ width: "100px" }}
  variant="secondary" 
  onClick={handleCloseModal}
>
  Cancel
</Button>

<Button
 className="button" 
  style={{ backgroundColor: "red", color: "white", width: "100px" }} // Ensures text is readable
  //variant="danger" 
  onClick={handleConfirmDelete}
  disabled={isDeletingProduct}
>
  {isDeletingProduct ? "Deleting..." : "Yes"}
</Button>


        </Modal.Footer>
      </Modal>

      {/* Title and Filter */}
      <Row className="d-flex justify-content-between align-items-center mt-3">
        <Col xs={12} md={5}>
          <h2>{title}</h2>
        </Col>

        <Modal show={showProductModal} onHide={handleProductModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Product Name<span style={{ color: 'red' }}>*</span></Form.Label>
              <Form.Control
                type="text"
                name="productName"
                value={productData.productName}
                onChange={handleProductDataChange}
                placeholder="Enter Product name"
                isInvalid={!!errors.productName}
              />
              <Form.Control.Feedback type="invalid">
                                      {errors.productName}
                                    </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group>
              <Form.Label>Product Type</Form.Label>
              <Form.Control
                type="text"
                name="type"
                value={productData.type}
                onChange={handleProductDataChange}
                placeholder="Enter Product type"
              />
            </Form.Group> */}
            <Form.Group  className="form-input">
              <Form.Label>Image File<span style={{ color: 'red' }}>*</span></Form.Label>
              <Form.Control type="file" onChange={handleImageUpload} 
              isInvalid={!!errors.product_image}
              />
              <Form.Control.Feedback type="invalid">
                                      {errors.product_image}
                                    </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="d-none">
              <Form.Label>Tenant</Form.Label>
              <Form.Control
                type="text"
                name="tenantId"
                //key={tenantId}
                value={productData.tenantId} // Displays the tenantId value
                onChange={handleProductDataChange} // Keeps track of changes but will not be triggered when disabled
                placeholder={tenantId}
                disabled // Ensures the field is displayed but not editable
              />

            </Form.Group>

            {/* <Form.Group>
              <Form.Label>Tenants</Form.Label>
              <Form.Control
                as="select"
                // value={productData.tenantId} // Bind to the tenant ID in cropData
                // onChange={handleTenantChange} // Update tenant ID in cropData
              >
                <option value="">Select Tenant</option>
                {tenantsList?.data?.tenants?.map((tenant) => (
                <option key={tenant.id} value={tenant.id}>
                  {tenant.name} 
                </option>
              ))}
              </Form.Control>
            </Form.Group> */}

            <Form.Group  className="form-input">
              <Form.Label>Region<span style={{ color: 'red' }}>*</span></Form.Label>
              <div className="date-picker-container">
              <Form.Control
                as="select"
                name="regionId" // Ensure the input has a name
                value={productData.regionId}
                onChange={(e) => handleProductDataChange(e)} // Pass the event to the handler
                isInvalid={!!errors.regionId}
              >
                <option value="">Select Region</option>
                {regionList?.regions?.map((region) => (
                  <option key={region.id} value={region.id}>
                    {region.region}
                  </option>
                ))}
              </Form.Control>

              <FaChevronDown className="calendar-icon" style={errors.regionId ? { marginRight: "20px" } : {}}/>
             
                </div>
                <Form.Control.Feedback className="d-block" type="invalid">
                                      {errors.regionId}
                                    </Form.Control.Feedback>
            </Form.Group>

            {/* <Form.Group>
              <Form.Label>Region</Form.Label>
              <Form.Control
                type="text"
                name="region"
                value={productData.region}
                onChange={handleProductDataChange}
                placeholder="Enter Region Name"
              />
            </Form.Group> */}

            {/* <Form.Group>
              <Form.Label>Region</Form.Label>
              <Form.Control
                as="select"
                // value={selectedRegion}
                // onChange={(e) => setSelectedRegion(e.target.value)}
              >
                <option value="">Select Region</option>
              </Form.Control>
            </Form.Group> */}
            <Form.Group  className="form-input">
              <Form.Label>Price<span style={{ color: 'red' }}>*</span></Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={productData.amount}
                onChange={handleProductDataChange}
                placeholder="Enter amount"
                isInvalid={!!errors.amount}
              />
               <Form.Control.Feedback type="invalid">
                                      {errors.amount}
                                    </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group>
              <Form.Label>Total Units</Form.Label>
              <Form.Control
                type="number"
                name="totalUnits"
                //value={totalUnits}
                value={productData.totalUnits}
                onChange={handleProductDataChange}
                placeholder="Enter the number of Units"
              />
            </Form.Group> */}
            <Form.Group  className="form-input">
              <Form.Label>Unit<span style={{ color: 'red' }}>*</span></Form.Label>
              <Form.Control
                type="text"
                name="unit"
                value={productData.unit}
                onChange={handleProductDataChange}
                placeholder="Enter the number of Units"
                isInvalid={!!errors.unit}
              />
              <Form.Control.Feedback type="invalid">
                                      {errors.unit}
                                    </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button className="button" onClick={addProduct} disabled={isAddingProduct}>
              {isAddingProduct ? "Adding..." : "Add Product"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Col
          xs={12}
          md={4}
          className="d-flex justify-content-end align-items-center"
        >
          {/* Filter Dropdown */}
          {showFilter && (
            <Dropdown className="dropdown mx-2">
              <Dropdown.Toggle
                className="dropdown-custom-components"
                id="dropdown-custom-components"
              >
                Weekly
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <Dropdown.Item eventKey="filter1">Weekly</Dropdown.Item>
                <Dropdown.Item eventKey="filter2">Monthly</Dropdown.Item>
                <Dropdown.Item eventKey="filter3">Yearly</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          {/* Date Range Input */}
          {/* <Form.Group className=" position-relative">
            <div
              className={`date-placeholder ${dateRange ? "hidden" : ""}`}
            ></div>
            <Form.Control
              type="date"
              value={dateRange}
              onChange={handleDateRangeChange}
              className="date-range-input"
              placeholder="Select Date Range"
            />
          </Form.Group> */}
          <Button className="button" onClick={handleProductModalShow}>
            {ICONS?.addPlusIcon && (
                                            <img src={ICONS.addPlusIcon} className="faPlusIcon" />
                                          )}
            Add New Product
          </Button>
        </Col>
      </Row>

      {/* Product List */}
      <Row className="mt-4">
        {productsList?.products && productsList.products.length > 0 ? (
          productsList.products.map((product) => (
            <ProductComponent key={product.id} product={product} onDelete={() => handleShowModal(product)} />
          ))
        ) : (
          <p>No products available</p>
        )}
      </Row>
    </div>
  );
};

export default ProductListComponent;
